module.exports = __webpack_public_path__ + "static/ConfigJson-0414a8f91f190eb73cbcc004d4097323.png";